import React, { FC } from "react";

interface FieldFullProps {
    label: string;
    value: string;
    hideEmpty?: boolean;
}

interface FieldSplitProps {
    leftLabel: string;
    leftValue: string;
    rightLabel: string;
    rightValue: string;
}

interface FieldRowProps {
    items: Array<{
        label: string;
        value: string | number;
    }>;
}

/**
 * Full-width card field component
 * Displays a label and value in a column layout
 */
export const FieldFull: FC<FieldFullProps> = ({ label, value, hideEmpty = true }) => {
    if (hideEmpty && !value?.trim()) {
        return null;
    }

    return (
        <div className="fwsm-row-full">
            <span className="fwsm-label">{label}</span>
            <strong className="fwsm-value">{value}</strong>
        </div>
    );
};

/**
 * Split card field component
 * Displays two label-value pairs side by side
 */
export const FieldSplit: FC<FieldSplitProps> = ({
    leftLabel, leftValue, rightLabel, rightValue,
}) => (
    <div className="fwsm-row-split">
        <div className="fwsm-col-left">
            <span className="fwsm-label">{leftLabel}</span>
            <strong className="fwsm-value">{leftValue}</strong>
        </div>
        <div className="fwsm-col-right">
            <span className="fwsm-label">{rightLabel}</span>
            <strong className="fwsm-value">{rightValue}</strong>
        </div>
    </div>
);

/**
 * Multi-column card field component
 * Displays multiple label-value pairs in a configurable grid layout
 * First column is left-aligned, last column is right-aligned, rest are center-aligned
 */
export const FieldRow: FC<FieldRowProps> = ({ items }) => (
    <div className="fwsm-row-grid" style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}>
        {items.map((item, index) => {
            let colClass = "fwsm-col-center";
            if (index === 0) {
                colClass = "fwsm-col-left";
            } else if (index === items.length - 1) {
                colClass = "fwsm-col-right";
            }
            
            return (
                <div key={index} className={`fwsm-col-item ${colClass}`}>
                    <span className="fwsm-label">{item.label}</span>
                    <strong className="fwsm-value">{String(item.value)}</strong>
                </div>
            );
        })}
    </div>
);